<template>
  <div>
    <SellHeader :img_header="header_image" header="เมนูคำสั่งซื้อ" link_back="sell/all"/>
    <MenuSell/>
    <Order_customer_main/>
  </div>
</template>

<script>
import MenuSell from "@/components/admin/sell/menusell/MenuSell";
import Order_customer_main from "@/components/admin/sell/Order_customer_main";
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/order_all.png";
export default {
  name: "OrderCustomerMain",
  components: {
    SellHeader,
    Order_customer_main,
    MenuSell
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
